import { render, staticRenderFns } from "./ImportacoesDelete.vue?vue&type=template&id=d7fce784&"
import script from "./ImportacoesDelete.vue?vue&type=script&lang=js&"
export * from "./ImportacoesDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports